import React from 'react'
import _ from 'lodash'
import {
  Div, H3, H4, Loading, P,
} from 'konsys-ui'
import {
  Col,
} from 'antd'
import 'moment-timezone'
import { useQuery } from '@apollo/react-hooks'
import { theme } from '../../../styles/_variables'
import { WAREHOUSE } from '../../../constants/graph/query'
import { Wrapper } from '../../../components/warehouses-components'
import { Remark } from '../../../components/common'

export default ({ props }) => {
  const { loading: infoLoading, data: infoData, error: infoError } = useQuery(WAREHOUSE, { variables: { id: parseInt(props.match.params.id, 10) } })
  if (infoLoading && _.isUndefined(infoData)) return <Loading center='true' />
  const { data } = infoData.findWarehouse
  return (
    <Div>
      <Div display='flex' alignItems='center' width='100%' justifyContent='space-between' margin='0 0 16px 0'>
        <H3 color={theme.color.primaryColor}>ข้อมูลคลังสินค้า</H3>
        <H4>ID: {data.warehouseCode}</H4>
      </Div>
      <Wrapper >
      <Div display='flex' alignItems='center' width='100%' margin='0 0 16px 0'>
        <Col span='6' offset={data.offset}>
          <P margin='0 8px 16px 0' width='100%' display='block' >ชื่อคลังสินค้า</P>
          <P margin='0 8px 16px 0' width='100%' display='block' color='#968595'>{data.warehouseName}</P>
        </Col>
        </Div>
      </Wrapper>
      <Wrapper >
      <Div display='flex' alignItems='center' width='100%' margin='0 0 16px 0'>
        <Col span='6' offset={data.offset}>
          <P margin='0 8px 16px 0' width='100%' display='block' >เลขที่</P>
          <P margin='0 8px 16px 0' width='100%' display='block' color='#968595'>{data.address.addressNo}</P>
        </Col>
        <Col span='6' offset={data.offset}>
          <P margin='0 8px 16px 0' width='100%' display='block' >แขวง/ตำบล</P>
          <P margin='0 8px 16px 0' width='100%' display='block' color='#968595'>{data.address.subDistrict}</P>
        </Col>
        <Col span='6' offset={data.offset}>
          <P margin='0 8px 16px 0' width='100%' display='block' >เขต/อำเภอ</P>
          <P margin='0 8px 16px 0' width='100%' display='block' color='#968595'>{data.address.district}</P>
        </Col>
        <Col span='6' offset={data.offset}>
          <P margin='0 8px 16px 0' width='100%' display='block' >จังหวัด</P>
          <P margin='0 8px 16px 0' width='100%' display='block' color='#968595'>{data.address.province}</P>
        </Col>
        </Div>
        <Div display='flex' alignItems='center' width='100%' margin='0 0 16px 0'>
        <Col span='6' offset={data.offset}>
          <P margin='0 8px 16px 0' width='100%' display='block' >รหัสไปรษณีย์</P>
          <P margin='0 8px 16px 0' width='100%' display='block' color='#968595'>{data.address.postcode}</P>
        </Col>
        </Div>
      </Wrapper>
      {/* <TextBetween
        title={{
          margin: '8px 0',
          text: 'วันที่สร้าง',
        }}
        content={{
          margin: '8px 0',
          text: moment.tz(data.createdAt, 'Asia/Bangkok').format('DD MMMM YYYY'),
          color: '#968595',
        }}
      />
      <TextBetween
        title={{
          margin: '8px 0',
          text: 'แก้ไขล่าสุด',
        }}
        content={{
          margin: '8px 0',
          text: moment.tz(data.updatedAt, 'Asia/Bangkok').format('DD MMMM YYYY'),
          color: '#968595',
        }}
      /> */}
      <Remark message='หมายเหตุ' description={'-'} />
    </Div>
  )
}
